<template>
  <ValidationObserver ref="wizardPage1" id="wizardPage1" name="wizardPage1">
  <div class="pb-5" data-wizard-type="step-content" data-wizard-state="current">
    <div class="mb-10 font-weight-bold text-dark" v-if="formData && referenceData">

      <appetite :brand="formData.brand"/>

      <div v-if="formData.brand === 'Fuse'" class="form-group row mb-0">
        <div class="col-6">
          <span class="font-weight-bold font-size-h4">
            Is the person initiating this proposal form a Broker?<span class="text-danger">*</span>
          </span>
          <b-form-group class="mt-2">
            <ValidationProvider rules="required" name="personCompletingForm" v-slot="{ errors }">
              <b-form-radio-group type="radio" v-model="formData.personCompletingForm.type" :is-read-only="isReadOnly">
                <b-form-radio type="radio" value="broker"><span class="font-weight-bold">YES</span></b-form-radio>
                <b-form-radio type="radio" value="client"><span class="font-weight-bold">NO</span></b-form-radio>
              </b-form-radio-group>
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-form-group>
        </div>
      </div>

      <div class="mb-4" v-if="formData.brand === 'CRI' || formData.personCompletingForm.type === 'broker'">

        <span class="font-weight-bolder">Tip:</span> As a broker, you can either complete the Proposal Form yourself or share the link with your customer to fill in directly.
        The form auto-saves as you go and stays editable until the final submission, so you or your customer can review and update it before submitting.
        <br/><br/>

        <span class="font-weight-bolder">
          IMPORTANT: If you are a general insurance broker completing this form on behalf of your client, please enter
          the client contact details in the 'Client Contacts' section on the next page.
        </span>

        <brokerage-details :brokerage-details="formData.brokerageDetails" @brokerContactUpdated="brokerContactUpdated"
                           :is-read-only="isReadOnly"></brokerage-details>
      </div>

    </div>
  </div>
  </ValidationObserver>
</template>

<style lang="scss">
</style>

<script>
import _ from "lodash";
import BrokerageDetails from "@/view/pages/wizard/motor-proposal-form/components/BrokerageDetails.vue";
import Appetite from "@/view/pages/wizard/motor-proposal-form/components/Appetite.vue";

export default {
  name: "WizardPage1",

  components: {
    Appetite,
    BrokerageDetails,
  },

  props: {
    formData: Object,
    referenceData: Object,
    isReadOnly: Boolean
  },
  
  data() {
    return {
    };
  },

  methods: {

    brokerContactUpdated: function() {
      // For CRI - Broker-contact is always the client's primary-contact
      if(this.formData.brand === 'CRI' || this.formData.personCompletingForm.type === 'broker') {
        // Copy broker-contact to primary-contact
        let brokerContact = _.get(this.formData, 'brokerageDetails.brokerContactDetails');
        let primaryContact = _.get(this.formData, 'clientContacts.primaryContact');

        if(brokerContact && primaryContact) {
          this.$set(primaryContact, 'firstName', brokerContact.firstName);
          this.$set(primaryContact, 'lastName', brokerContact.lastName);
          this.$set(primaryContact, 'title', brokerContact.title);
          this.$set(primaryContact, 'email', brokerContact.email);
          this.$set(primaryContact, 'phone', brokerContact.phone);
          this.$set(primaryContact, 'mobile', brokerContact.mobile);
        }
      }
    }
  },
};
</script>
